import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) =>({
	firstGrid: {
		display: 'block',
		alignItems: 'center',
		height: '100vh',
		maxHeight: '100vh',
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '16% 0px'
	},
	logo: {
		marginTop: '0px',
		marginLeft: '-17px',
		height: '19%',
		width: '78%',
	},
	text: {
		color: theme.palette.login.text.main,
		textTransform: 'uppercase',
		fontFamily: 'Montserrat',
		marginTop: '20px !important'
	},
	loginForm: {
		height: '100%',
		backgroundColor: `${theme.palette.login.background?.default}`,
		textAlign: 'center',
		maxHeight: '100%',
		overflow: 'hidden'
	},
	center: {
		// justifyContent: 'left',
		textAlign: 'left',
		display: 'block',
		verticalAlign: 'middle',
		horizontalAlign: 'middle',
		padding: '10% 0px 25% 0px'
	},
	userlogo: {
		height: '9vh',
		position: 'relative',
		margin: 'auto',
		display: 'block'
	},
	textfield: {
		top: '20px',
		width: '85%',
		'& input::placeholder': {
			fontSize: '12px',
			fontFamily: 'Montserrat !important',
			fontStyle: 'italic'
		},
		'& input:active': {
			background: `${theme.palette.login.background?.textFieldBackground}`
		},
		'& input:focus': {
			background: `${theme.palette.login.background?.textFieldBackground}`
		},
		'& input:hover': {
			background: `${theme.palette.login.background?.textFieldBackground}`
		},
		'& input': {
			paddingLeft: '10px',
			backgroundColor: `${theme.palette.login.background?.textFieldBackground}`,
		},
		backdropFilter: 'blur(10px)',
		borderRadius: '4px',
		marginLeft: '14% !important',
		marginBottom: '10px !important',
		fontFamily: 'Montserrat !important'
	},
	textfield1: {
		top: '20px',
		width: '85%',
		'& input::placeholder': {
			fontSize: '12px',
			fontFamily: 'Montserrat !important',
			fontStyle: 'italic'
		},
		'& input:active': {
			background: 'transparent'
		},
		'& input:focus': {
			background: 'transparent'
		},
		'& input:hover': {
			background: 'transparent'
		},
		'& input': {
			paddingLeft: '10px',
			background: 'transparent'
		},
		background: `${theme.palette.login.background?.textFieldBackground}`,
		backdropFilter: 'blur(10px)',
		borderRadius: '4px',
		marginLeft: '14% !important',
		marginBottom: '10px !important',
		fontFamily: 'Montserrat !important',
		paddingLeft: '10px'
	},
	loginBtn: {
		top: '30px',
		width: '85%',
		background: `${theme.palette.login.background?.button} !important`,
		marginLeft: '14% !important',
		fontFamily: 'Montserrat !important',
		fontWeight: 'bolder !important'
	},
	img: {
		paddingLeft: '10px',
		width: '70%'
	},
	pwdErr: {
		top: '13px',
		position: 'relative',
		color: `${theme.palette.error.main}`,
		paddingLeft: '16%',
		paddingTop: '10px',
		paddingBottom: '10px',
		fontFamily: 'Montserrat !important',
		fontSize: '12px',
		fontWeight: '600',
		textAlign: 'left',
		paddingRight: '20%',
		verticalAlign: 'middle',
		'& img': {
			paddingRight: '5px'
		}
	},
	emailErr: {
		top: '13px',
		position: 'relative',
		color: `${theme.palette.error.main}`,
		paddingLeft: '20%',
		fontFamily: 'Montserrat !important',
		fontSize: '12px',
		textAlign: 'left',
		paddingRight: '20%'
	},
	field: {
		height: '35px'
	},
	rememberTxt: {
		color: `${theme.palette.login.text.tagLine}`,
		fontWeight: '600',
		fontSize: '16px',
		lineHeight: '25px',
		fontFamily: 'Montserrat !important',
		'& span': {
			fontSize: '14px !important'
		},
		width: '45%',
		float: 'left'
	},
	forgotTxt: {
		width: '50%',
		float: 'right',
		color: `${theme.palette.login.text.forgot}`,
		fontFamily: 'Montserrat !important',
		fontSize: '16px !important',
		lineHeight: '25px',
		textDecoration: 'none',
		fontWeight: '600',
		textAlign: 'right'
	},
	errorText: {
		top: '20px',
		width: '85%',
		background: `${theme.palette.login.background?.textFieldBackground}`,
		backdropFilter: 'blur(10px)',
		borderRadius: '4px',
		marginLeft: '14% !important',
		marginBottom: '10px !important',
		fontFamily: 'Montserrat !important',
		borderBottom: `2px solid ${theme.palette.error.main} `,
		'& .MuiInput-root::after': {
		borderBottom: '2px solid transparent',
		},
		'& input::placeholder': {
		fontSize: '12px',
		fontFamily: 'Montserrat !important',
		fontStyle: 'italic',
		},
	},

}));

export default useStyles;
